import React from "react";
import { AnimatePresence } from "framer-motion";
import { useLocation, Outlet } from "react-router-dom";
import Header from "./Header";
import { TradingFooter } from "./Footer";
import { useScrollToTop } from "../../hooks/useScrollToTop";

const Layout = () => {
  const location = useLocation();
  useScrollToTop();

  return (
    <>
      <Header />

      <AnimatePresence mode="wait">
        <main key={location.pathname}>
          {/* 🔥 THIS IS THE FIX */}
          <Outlet />
        </main>
      </AnimatePresence>

      <TradingFooter />
    </>
  );
};

export default Layout;
